import { PotencyLimits } from 'sigma-mappings';

const dropdownLimits = [
  {
    text: 'engineering.chromatography.methods-and-diagnostics.fill-with-upper-limit',
    icon: 'fas fa-arrow-up',
    type: PotencyLimits.UPPER,
  },
  {
    text: 'engineering.chromatography.methods-and-diagnostics.fill-with-average',
    icon: 'fas fa-arrows-alt-v',
    type: PotencyLimits.AVERAGE,
  },
  {
    text: 'engineering.chromatography.methods-and-diagnostics.fill-with-lower-limit',
    icon: 'fas fa-arrow-down',
    type: PotencyLimits.LOWER,
  },
];

export default dropdownLimits;
